export enum SpotlightSearchTab {
  ALL = 'all',
  ESTATES = 'estates',
  DOCUMENTS = 'documents',
  ASSETS = 'assets',
  LIABILITITES = 'liabilitites'
}
